module.exports = __webpack_public_path__ + "assets/img/img-training-06.02ef9820.jpg";